import { render, staticRenderFns } from "./addCommunity.vue?vue&type=template&id=f5f58f40"
import script from "./addCommunity.vue?vue&type=script&lang=js"
export * from "./addCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports